/* @flow */
import * as React from 'react';
import classnames from 'classnames/bind';
import { Link } from 'react-router';
import type { List, Map } from 'immutable';
import { connect } from 'react-redux';
import createDebugger from 'debug';
import { Spinner } from 'trustar/components';
import {
  ExploreIcon,
  DashboardIcon,
  LogoSplunkTS,
  TrustarAdminIcon
} from 'trustar/icons';

const debug = createDebugger('app:components:App'); // eslint-disable-line no-unused-vars
import styled, { css } from 'styled-components';
import s from './AppHeader.styl';
const cx = classnames.bind(s);
import { currentBaseRoute } from 'modules/router/getters';
import { getters as AppGetters, actions as AppActions } from 'modules/app';
import { getters as EnclaveGetters } from 'modules/enclave';
import * as Profile from 'modules/profile';
import SearchBox from './search/SearchBar';
import { VerticalSeperator } from 'trustar/components/VerticalSeperator';
import { Icon, IconLookup } from 'trustar-2.0/components';
import { Button, IconButton } from 'trustar-2.0/components/Button';
import { ThemeColors } from 'trustar-2.0/themes/default';
import {
  DropdownWrap,
  DropdownWrapMenuItem
} from './browse/components/DropdownWrap';
import ConnectedDesignSystemProvider from 'components/ConnectedDesignProvider';
import {ROUTES_THAT_SHOULD_NOT_HAVE_SUBMIT_BUTTON} from 'modules/app/constants';
import type { Enclave } from 'modules/enclave/types';

type HeaderProps = {
  palette: Object,
  disabled: boolean,
  profile: Map<any, any>,
  options: Map<any, any>,
  loading: boolean,
  adminRole: string,
  pathname: string,
  currentBaseRoute: string,
  isTrialUser: boolean,
  enclaves: List<Enclave>,
};
class Header extends React.Component {
  props: HeaderProps;

  state = {
    isOpen: false
  };

  handleToggleMenu = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const {
      loading,
      options,
      adminRole,
      profile,
      palette,
      isTrialUser,
      currentBaseRoute,
      enclaves,
    } = this.props;
    const { isOpen } = this.state;
    const showSubmitButton = !ROUTES_THAT_SHOULD_NOT_HAVE_SUBMIT_BUTTON.includes(currentBaseRoute) && enclaves.size > 0;

    // TODO REMOVE ADMIN BAN
    return (
      <div className={cx('Header', { isAdmin: !!adminRole })}>
        <Link to='/browse/reports' className={cx('navLink', 'trustarIcon')}>
          <LogoSplunkTS color={palette.logoFill} />
          {adminRole && <TrustarAdminIcon />}
        </Link>
        <SearchBox />
        <StyledActionsMenu showAdminRole={!!adminRole}>
          <ConnectedDesignSystemProvider>
            <DropdownWrap
              dropdownCyId='dropdown'
              dropdownMenuCyId='dropdown-menu'
              direction='down'
              openOnClick
              dropdownItemContainerBorderStyle={'transparent'}
              menuItems={[
                <StyledDropdownMenuLink key={1} data-cy='create-report-link' to='/create'>
                  <StyledDropdownWrapMenuItem>
                    Report
                  </StyledDropdownWrapMenuItem>
                </StyledDropdownMenuLink>,
                <StyledDropdownMenuLink key={2} data-cy='create-ioc-link' to='/create/iocs'>
                  <StyledDropdownWrapMenuItem>
                    Indicator
                  </StyledDropdownWrapMenuItem>
                </StyledDropdownMenuLink>
              ]}>
              <StyledButtonContainer>
                {showSubmitButton &&
                  <IconButton icon={IconLookup.PLUS} stretched size='medium' cyid='submit'>
                   Submit
                  </IconButton>
                }
              </StyledButtonContainer>
            </DropdownWrap>
          </ConnectedDesignSystemProvider>
          {adminRole && <span className={'adminBanner'}>{`${adminRole}`}</span>}
        </StyledActionsMenu>
      </div>
    );
  }
}

const StyledButtonContainer = styled.span`
  width: 12rem;
  display: inline-block;

`;

const StyledDropdownMenuLink = styled(Link).attrs({
  'data-cy': (props) => props.cyId,
})`
  display: inline-block;

`;
//     box-shadow: 0 0 0 1px ${({ theme }) => theme.ThemeColors.BORDER.hex};
const StyledDropdownWrapMenuItem = styled.div`
  && {
    font-size: 1.167rem;
    text-align: center;
    width: 11rem;
    padding: 0.75rem 1rem;
    margin: 1px 0 0 0.5rem;
    box-shadow: 3px 3px 11px -8px ${({ theme }) => theme.ThemeColors.BOX_SHADOW.hex};
    border-left: 0.5rem solid transparent;
    cursor: pointer;
    background-color: ${({ theme }) => theme.ThemeColors.SURFACE_LIGHTEST.hex};
    color: ${({ theme }) => theme.ThemeColors.TEXT.hex};

    :hover {
      border-left: 0.5rem solid ${({ theme }) => theme.ThemeColors.PRIMARY.hex};
      background-color: ${({ theme }) =>
        theme.ThemeColors.LIGHT_GRAY_SURFACE.hex};
      color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
    }

    a {
      color: unset;
      background-color: unset;
    }
  }
`;

const StyledActionsMenu = styled.div`
  display: flex;
  align-items: center;
  min-width: 20rem;
  position: relative;
  width: ${props => (props.showAdminRole ? '28%' : '17%')};
  margin-left: ${props => (props.showAdminRole ? '2rem' : '18rem')};

  .adminBanner {
    width: 8.6rem;
    font-size: 1.25rem;
    text-transform: uppercase;
    color: inherit;
    text-align: right;
    white-space: nowrap;
    flex-grow: 1;
    margin-left: -1rem;
  }
`;

const mapState = state => ({
  options: AppGetters.options(state),
  profile: Profile.getters.profile(state),
  adminRole: Profile.getters.adminRole(state),
  isTrialUser: Profile.getters.isTrialUser(state),
  palette: AppGetters.getHeaderPalette(state),
  currentBaseRoute: currentBaseRoute(state),
  enclaves: EnclaveGetters.enclaves(state),
});

const mapDispatch = {};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...dispatchProps,
  ...stateProps
});

export default connect(mapState, mapDispatch, mergeProps)(Header);



// WEBPACK FOOTER //
// ./src/app/components/AppHeader.js